import { isDevMode } from '@angular/core';
import {
  ActionReducerMap,
  MetaReducer
} from '@ngrx/store';
import { AppState, reducer } from './app.reducer';

export interface State {
  mainState: AppState;
}

export const reducers: ActionReducerMap<State> = {
  mainState: reducer
};


export const metaReducers: MetaReducer<State>[] = isDevMode() ? [] : [];
